/**
 * B2C sometimes returns OAuth params as "#/state=...&code=..." (HashRouter
 * path-style). MSAL expects "#state=..." / "#code=..." without the slash
 * after "#". HashRouter's history also re-inserts a leading "/" on boot, so
 * call this again in useLayoutEffect after the router mounts and before
 * MsalProvider's handleRedirectPromise (useEffect).
 *
 * Keep the early copy in public/asset-load-error-handler.v2.js in sync.
 *
 * @returns {boolean} true if the hash was rewritten
 */
export const rewriteMsalPathStyleOAuthHash = () => {
  try {
    const authHash = window.location.hash;
    if (!authHash || authHash.length < 4) return false;
    if (!/^#\/(state|code|client_info|error)=/i.test(authHash)) {
      return false;
    }
    const fixedHash = `#${authHash.slice(2)}`;
    window.history.replaceState(
      window.history.state,
      document.title,
      `${window.location.pathname}${window.location.search}${fixedHash}`,
    );
    return true;
  } catch (_e) {
    return false;
  }
};
